
export class SdpInspector {
  public getMediaKinds(sdp: string | undefined): string[] {
    if (!sdp) return [];
    const kinds: string[] = [];
    for (const line of sdp.split(/\r?\n/)) {
      const match = line.match(/^m=(\w+)\s/);
      if (match) kinds.push(match[1]);
    }
    return kinds;
  }

  /**
   * Extract the SDP session ID from the o= line.
   * Format: o=<username> <sess-id> <sess-version> <nettype> <addrtype> <unicast-address>
   * Returns undefined if the o= line is missing or malformed.
   */
  public getSessionId(sdp: string | undefined): string | undefined {
    if (!sdp) return undefined;
    for (const line of sdp.split(/\r?\n/)) {
      const match = line.match(/^o=\S+\s+(\d+)\s/);
      if (match) return match[1];
    }
    return undefined;
  }
}
